import { useQuery } from 'react-query';
import { ActivityService } from '../api/ActivityService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListActivity = (
  [id, page_no, selectedAssignee, selectedSprint, selectedInactiveUser],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['activity-list', id, page_no, selectedAssignee, selectedSprint, selectedInactiveUser],
    () =>
      ActivityService.listTask({
        id,
        page_no,
        selectedAssignee,
        selectedSprint,
        selectedInactiveUser
      }),
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

export {
  useListActivity
};
